<mat-sidenav-container
  autosize="true"
  [ngStyle]="{ height: !showSideNavbar ? '100%' : 'unset' }"
  [ngClass]="{ adminHeader: role === '1' || role === '2' }"
>
  <mat-sidenav
    mode="side"
    opened
    fixedInViewport="true"
    *ngIf="showSideNavbar"
    [ngStyle]="{ display: !showSideNavbar ? 'none' : 'block' }"
  >
    <div
      class="common-side-navbar"
      [ngClass]="{
        'common-side-navbar-shrinkedView': !isFullView,
        'common-side-navbar-expandedView': isFullView
      }"
    >
      <div class="pt-1 text-center">
        <!-- <img
          *ngIf="isFullView"
          src="assets/RA LOGO-01.svg"
          alt="Ravi's Academy"
          style="cursor: pointer"
          class=""
          [routerLink]="['/new-dashboard']"
          width="200"
          height="48px"
        />
        <img
          *ngIf="!isFullView"
          src="assets/logo-favicon.svg"
          alt="Ravi's Academy"
          style="cursor: pointer"
          class=""
          [routerLink]="['/new-dashboard']"
          width="200"
          height="30px"
        /> -->
        <img
          [src]="
            isFullView ? 'assets/RA LOGO-01.svg' : 'assets/logo-favicon.svg'
          "
          alt="Ravi's Academy"
          [routerLink]="['/new-dashboard']"
          class="common-side-navbar__side-logo"
          [ngClass]="{ 'common-side-navbar__side-logo--small': !isFullView }"
        />
      </div>
      <div
        class="pt-1 pb-1 common-side-navbar-controlText text-left"
        (click)="changeView()"
      >
        {{ isFullView ? "<< Collapse" : "Expand >>" }}
      </div>
      <div class="d-flex justify-space-between flex-d-column">
        <div class="d-flex flex-d-column">
          <ng-container
            *ngFor="let svgObj of modifiedSvgs; let svgIndex = index"
          >
            <div
              *ngIf="
                svgObj.roles.includes(role) &&
                (svgObj.default ||
                  (svgObj.isAcademic && studentAccess.academic) ||
                  (svgObj.isTestPrep && studentAccess.testPrep) ||
                  (svgObj.isPackage && studentAccess.package))
              "
              class="common-side-navbar-expandedView-optionHolder"
            >
              <div
                class="common-side-navbar-expandedView-optionHolder-option justify-space-between"
                [ngClass]="{
                  'common-side-navbar-expandedView-optionHolder-option-active':
                    svgObj.routePath.includes(currentRoute)
                }"
                (click)="expandOption(svgIndex)"
                matTooltip="{{ svgObj.svgName }}"
                matTooltipPosition="after"
              >
                <div class="d-flex items-center g-1" style="gap: 3px">
                  <img
                    class="common-side-navbar-expandedView-optionHolder-option-optionIcon"
                    [ngClass]="{
                      'common-side-navbar-expandedView-optionHolder-option-optionIcon-active':
                        svgObj.routePath.includes(currentRoute) ||
                        svgObj.isExpanded
                    }"
                    [src]="svgObj.imgPath"
                  />
                  <div *ngIf="isFullView">
                    {{ svgObj.svgName }}
                  </div>
                </div>
                <div
                  *ngIf="svgObj.subSvgs.length > 0"
                  class="d-flex items-center"
                >
                  <mat-icon *ngIf="svgObj.isExpanded"
                    >keyboard_arrow_up</mat-icon
                  >
                  <mat-icon *ngIf="!svgObj.isExpanded"
                    >keyboard_arrow_down</mat-icon
                  >
                </div>
              </div>
              <div *ngIf="svgObj.isExpanded">
                <!-- <div
                  *ngIf="!isFullView"
                  style="
                    display: grid;
                    gap: 10px;
                    padding: 16px;
                    margin: 0 !important;
                  "
                >
                  <img
                    routerLink="/student-learning"
                    height="18px"
                    style="cursor: pointer"
                    src="assets/images/side-navbar/learning modules.svg"
                    matTooltip="Learning Module"
                    matTooltipPosition="after"
                  />
                  <img
                    routerLink="/practice-test"
                    height="18px"
                    style="cursor: pointer"
                    src="assets/images/side-navbar/practice tests.svg"
                    matTooltip="Practice Tests"
                    matTooltipPosition="after"
                  />
                </div> -->
                <!-- <div *ngIf="isFullView"> -->
                <div>
                  <div
                    *ngFor="
                      let subSvg of svgObj.subSvgs;
                      let subSvgIndex = index
                    "
                    (click)="subNavigation(svgIndex, subSvgIndex)"
                    [ngClass]="{
                      'common-side-navbar-expandedView-optionHolder-option-subOption-active':
                        subSvg.isRouteActive
                    }"
                    class="d-flex items-center g-2 common-side-navbar-expandedView-optionHolder-option-subOption"
                    matTooltip="{{ subSvg.subSvgName }}"
                    matTooltipPosition="after"
                  >
                    <!-- <div *ngIf="isFullView">
                    <div
                      [ngClass]="{
                        'common-side-navbar-expandedView-optionHolder-option-subOption-icon-active':
                          subSvg.isRouteActive
                      }"
                      class="common-side-navbar-expandedView-optionHolder-option-subOption-icon"
                    ></div>
                  </div> -->
                    <!-- <img
                      *ngIf="
                        isFullView && subSvg.subSvgName == 'Learning Modules'
                      "
                      routerLink="/student-learning"
                      height="18px"
                      style="cursor: pointer"
                      src="assets/images/side-navbar/learning modules.svg"
                      matTooltip="Learning Module"
                      matTooltipPosition="after"
                    />

                    <img
                      *ngIf="
                        isFullView && subSvg.subSvgName == 'Practice Tests'
                      "
                      routerLink="/practice-test"
                      height="18px"
                      style="cursor: pointer"
                      src="assets/images/side-navbar/practice tests.svg"
                      matTooltip="Practice Tests"
                      matTooltipPosition="after"
                    /> -->
                    <!-- [routerLink]="[subSvg.routePath]" -->
                    <img
                      height="18px"
                      style="cursor: pointer"
                      [src]="subSvg.imgPath"
                      [matTooltip]="subSvg.subSvgName"
                      matTooltipPosition="after"
                    />

                    <div *ngIf="isFullView">
                      {{ subSvg.subSvgName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- <div class="common-side-navbar-expandedView-optionHolder">
            <div class="common-side-navbar-expandedView-optionHolder-option">
              <img
                class="common-side-navbar-expandedView-optionHolder-option-optionIcon"
                src="assets/images/side-navbar/classes.svg"
              />
              <div>Classes</div>
            </div>
          </div>
          <div class="common-side-navbar-expandedView-optionHolder">
            <div class="common-side-navbar-expandedView-optionHolder-option">
              <img
                class="common-side-navbar-expandedView-optionHolder-option-optionIcon"
                src="assets/images/side-navbar/coaching.svg"
              />
              <div>Coaching</div>
            </div>
          </div>
          <div class="common-side-navbar-expandedView-optionHolder">
            <div class="common-side-navbar-expandedView-optionHolder-option">
              <img
                class="common-side-navbar-expandedView-optionHolder-option-optionIcon"
                src="assets/images/side-navbar/testPrep.svg"
              />
              <div>Test Prep</div>
            </div>
          </div>
          <div class="common-side-navbar-expandedView-optionHolder">
            <div class="common-side-navbar-expandedView-optionHolder-option">
              <img
                class="common-side-navbar-expandedView-optionHolder-option-optionIcon"
                src="assets/images/side-navbar/assignments-hover.svg"
              />
              <div>Assignments</div>
            </div>
          </div> -->
        </div>
        <!-- <div class="common-side-navbar-expandedView-paymentCard-holder">
          <div
            class="d-flex flex-d-column justify-space-between common-side-navbar-expandedView-paymentCard"
            [ngStyle]="{
              padding: isFullView ? '14px 18px 18px 10px' : '7px 0px 13px 1px'
            }"
          >
            <div class="d-flex justify-space-between items-center">
              <img src="assets/images/side-navbar/pay-1x.webp" />
              <div
                *ngIf="isFullView"
                class="common-side-navbar-expandedView-paymentCard-moneyText"
              >
                $0
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div style="padding-left: 0.6rem">
                <div
                  class="common-side-navbar-expandedView-paymentCard-dueText"
                >
                  Due on
                </div>
                <div
                  class="common-side-navbar-expandedView-paymentCard-dueDate"
                >
                  {{ isFullView ? "Sep 26, 2023" : "Sep 26" }}
                </div>
              </div>
              <div
                *ngIf="isFullView"
                class="common-side-navbar-expandedView-paymentCard-payNowBtn"
              >
                Pay Now
              </div>
            </div>
          </div>
        </div> -->
        <div style="bottom: 0; position: fixed">
          <div style="padding: 10px">
            <app-common-user-info
              [isCollapse]="isFullView"
            ></app-common-user-info>
          </div>

          <div
            *ngIf="!isFullView"
            style="
              display: flex;
              flex-direction: column;
              cursor: pointer;
              padding: 10px 10px 20px 10px;
            "
            matTooltip="Log Out"
            matTooltipPosition="after"
            (click)="logout()"
          >
            <img src="assets/images/side-navbar/log-out.svg" height="20px" />
            <span
              style="font-family: Montserrat; font-size: 12px; font-weight: 600"
              >Log Out</span
            >
          </div>
          <div
            *ngIf="isFullView"
            style="
              display: flex;
              gap: 10px;
              cursor: pointer;
              padding: 5px 20px 20px 20px;
            "
            (click)="logout()"
            matTooltip="Log Out"
            matTooltipPosition="after"
          >
            <img src="assets/images/side-navbar/log-out.svg" height="20px" />
            <span
              style="font-family: Montserrat; font-size: 12px; font-weight: 600"
              >Log Out</span
            >
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content
    #sidenavContent
    (scroll)="onContentScroll($event)"
    [ngStyle]="{ 'margin-left': !showSideNavbar ? '0px' : 'unset' }"
  >
    <!-- <img
     
      class="common-side-navbar__logo"
      src="assets/RA LOGO-01.svg"
      *ngIf="
        (role === '3' || role === '4') &&
        currentRoute !== '/login' &&
        currentRoute !== '/'
      "
    /> -->

    <div
      *ngIf="
        (role === '3' || role === '4') &&
        currentRoute !== '/login' &&
        currentRoute !== '/' &&
        currentRoute !== '/stripe-payment' &&
        !isFullView
      "
      class="common-side-navbar__collapse"
      [ngClass]="{ scrolled: isScrolled }"
    >
      <img
        class="common-side-navbar__collapse--img"
        src="assets/RA LOGO-01.svg"
      />

      <div class="common-side-navbar__profile-container">
        <!-- <img src="assets/images/dashboard/user-ppic.svg" alt="User" class="common-side-navbar__profile" /> -->
        <p class="username-text">{{ fullName }}</p>
      </div>
    </div>
    <div
      *ngIf="
        (role === '3' || role === '4') &&
        currentRoute !== '/login' &&
        currentRoute !== '/' &&
        currentRoute !== '/stripe-payment'
      "
      class="common-side-navbar__collapse common-side-navbar__collapse__mobile"
      [ngClass]="{ scrolled: isScrolled }"
    >
      <img
        class="common-side-navbar__collapse--img"
        src="assets/RA LOGO-01.svg"
      />
      <div class="common-side-navbar__profile-container">
        <!-- <img src="assets/images/dashboard/user-ppic.svg" alt="User" class="common-side-navbar__profile" /> -->
        <p class="username-text">{{ fullName }}</p>
      </div>
    </div>
    <div
      *ngIf="
        role === '4' &&
        currentRoute !== '/login' &&
        currentRoute !== '/' &&
        currentRoute !== '/stripe-payment' &&
        currentRoute !== '/student-payments' &&
        currentRoute !== '/profile' &&
        !currentRoute.includes('/report')
      "
      class="flex justify-center dashboard__children-holder"
    >
      <div class="dashboard__children dashboard-viewdata">
        <span>
          {{
            childrenLoading
              ? "Fetching Children"
              : children.length > 0
              ? "View data for"
              : "No children found"
          }}
        </span>
        <mat-select
          [(ngModel)]="selectedChild"
          (selectionChange)="setchildren()"
          class="capitalize dashboard__children__select"
          *ngIf="!childrenLoading && children.length > 0"
        >
          <mat-option
            *ngFor="let child of children; let i = index"
            class="capitalize dashboard__children__select__option"
            [value]="i"
            >{{ child.first_name }}</mat-option
          >
        </mat-select>
      </div>
    </div>

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
<div *ngIf="showMobileNavbar">
  <!-- <div
    class="common-side-navbar-mobile"
    [ngClass]="{
      'common-side-navbar-mobile-shrinkedView': !isFullView,
      'common-side-navbar-mobile-expandedView': isFullView
    }"
  > -->
  <div class="common-side-navbar-mobile common-side-navbar-mobile-expandedView">
    <ng-container *ngFor="let svgObj of modifiedSvgs; let svgIndex = index">
      <div
        *ngIf="
          svgObj.roles.includes(role) &&
          (svgObj.default ||
            (svgObj.isAcademic && studentAccess.academic) ||
            (svgObj.isTestPrep && studentAccess.testPrep) ||
            (svgObj.isPackage && studentAccess.package))
        "
        class="common-side-navbar-mobile-expandedView-optionHolder"
      >
        <!-- <div
          class="common-side-navbar-mobile-expandedView-optionHolder-option justify-between"
          [ngClass]="{
            'common-side-navbar-mobile-expandedView-optionHolder-option-active':
              svgObj.routePath.includes(currentRoute)
          }"
          (mouseover)="changeSvg(svgIndex, true)"
          (mouseout)="changeSvg(svgIndex, false)"
          (click)="expandOptionMobile(svgIndex, overlayPannel, $event)"
        > -->
        <div
          class="common-side-navbar-mobile-expandedView-optionHolder-option justify-between"
          [ngClass]="{
            'common-side-navbar-mobile-expandedView-optionHolder-option-active':
              svgObj.routePath.includes(currentRoute)
          }"
          (click)="expandOptionMobile(svgIndex, overlayPannel, $event)"
        >
          <div
            class="items-center"
            style="display: flex; flex-direction: column"
          >
            <img
              class="common-side-navbar-mobile-expandedView-optionHolder-option-optionIcon"
              [ngClass]="{
                'common-side-navbar-mobile-expandedView-optionHolder-option-optionIcon-active':
                  svgObj.routePath.includes(currentRoute) || svgObj.isExpanded
              }"
              src="{{ svgObj.imgPath }}"
            />
            <div style="width: max-content">
              {{ svgObj.svgName }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="common-side-navbar-mobile-expandedView-optionHolder">
      <div
        class="common-side-navbar-mobile-expandedView-optionHolder-option justify-between"
        [ngClass]="{
          'common-side-navbar-mobile-expandedView-optionHolder-option-active':
            testPrepClicked
        }"
      >
        <div
          class="items-center"
          style="display: flex; flex-direction: column"
          routerLink="/profile"
        >
          <img
            class="common-side-navbar-mobile-expandedView-optionHolder-option-optionIcon common-side-navbar-mobile-no-filter"
            [ngClass]="{
              'common-side-navbar-mobile-expandedView-optionHolder-option-optionIcon-active':
                testPrepClicked
            }"
            src="assets/images/dashboard/user-ppic.svg"
          />
          <div *ngIf="isFullView">Profile</div>
        </div>
      </div>
    </div>
    <div class="common-side-navbar-mobile-expandedView-optionHolder">
      <div
        class="common-side-navbar-mobile-expandedView-optionHolder-option justify-between"
        [ngClass]="{
          'common-side-navbar-mobile-expandedView-optionHolder-option-active':
            testPrepClicked
        }"
      >
        <div
          style="display: flex; flex-direction: column; cursor: pointer"
          (click)="logout()"
        >
          <img
            src="assets/images/side-navbar/log-out.svg"
            height="20px"
            class="common-side-navbar-mobile-no-filter"
          />
          <span
            style="
              font-family: Montserrat;
              font-size: 12px;
              font-weight: 600;
              width: max-content;
            "
            >Log Out</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<p-overlayPanel #overlayPannel>
  <div class="overlayPannel">
    <!-- <span style="width: max-content; display: flex; gap: 5px">
      <img
        height="18px"
        style="cursor: pointer"
        src="assets/images/side-navbar/learning modules.svg"
        matTooltip="Learning Module"
        matTooltipPosition="after"
      />
      <span
        class="overlayPannel__text"
        (click)="toggleOverlay(overlayPannel, $event)"
        [routerLink]="['/student-learning']"
        >Learning Modules</span
      >
    </span>
    <span style="width: max-content; display: flex; gap: 5px">
      <img
        height="18px"
        style="cursor: pointer"
        src="assets/images/side-navbar/practice tests.svg"
        matTooltip="Practice Tests"
        matTooltipPosition="after"
      />
      <span
        class="overlayPannel__text"
        (click)="toggleOverlay(overlayPannel, $event)"
        [routerLink]="['/practice-test']"
        >Practice Tests</span
      >
    </span> -->
    <span
      style="width: max-content; display: flex; gap: 5px"
      *ngFor="let subSvg of mobileExpandedSvgs"
    >
      <img height="18px" style="cursor: pointer" [src]="subSvg.imgPath" />
      <span
        class="overlayPannel__text"
        [ngClass]="{
          overlayPannel__text__active: currentRoute === subSvg.routePath
        }"
        (click)="
          toggleOverlay(overlayPannel, $event);
          subMobileNavigation(subSvg.routePath)
        "
        >{{ subSvg.subSvgName }}</span
      >
      <!-- [routerLink]="[subSvg.routePath]" -->
    </span>
  </div>
</p-overlayPanel>
